import {useUser} from "../context/UserContext";
import {useHistory} from "react-router-dom";
import {useState} from "react";
import ApiService from "../services/ApiService";
import {Button, Form, Input} from "antd";

export default function ResetPasswordSend() {
    const {user, setToken, isAuth, setSettings} = useUser();
    const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false)
    const [loading, setLoading] = useState(false)

    const sendLink = async (form) => {
        setLoading(true)
        const res = await ApiService.Auth.SendResetPasswordMail(form)
        setLoading(false)
        if(res.success) {
            setShowSuccess(true)
        }
    }

    return (
        <>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                <div style={{width: '50%', height: '50%', display: 'flex', alignItems: 'center', minHeight: 500, minWidth: 1000}}>
                    <div style={{flex: 1, backgroundColor: '#035781', height: '100%', width: '100%', display: 'flex', alignItems: 'center'}}>
                        <div style={{width: '100%', display: "flex", alignItems: 'center', flexDirection: 'column'}}>
                            <img src={'/LogoB41.png'} width={256} height={256}/>
                        </div>
                    </div>
                    <div style={{flex: 1, height: '100%', backgroundColor: '#fff', display: 'flex', alignItems: 'center'}}>
                        <div style={{display: 'flex', flexDirection: 'column', width: '100%', marginLeft: '10%', marginRight: '10%'}}>
                            <div style={{fontSize: '23pt'}}>
                                Reset Password
                            </div>
                            <br/>
                            <Form
                                name="basic"
                                initialValues={{ remember: true }}
                                autoComplete="off"
                                onFinish={sendLink}
                            >
                                <Form.Item
                                    name="email"
                                    rules={[{ required: true, message: 'Please input your email!' }]}
                                >
                                    <Input
                                        placeholder={'user@mail.com'}
                                        style={{
                                            fontSize: '13pt'
                                        }}
                                    />
                                </Form.Item>

                                <div style={{width: 400}}>
                                    <Button
                                        loading={loading}
                                        type="primary"
                                        htmlType="submit"
                                        size={'large'}
                                        style={{fontSize: '13pt', padding: 'none',
                                            paddingBottom: 8}}
                                    >
                                        <div style={{marginTop: -2}}>
                                            Send Reset Link
                                        </div>
                                    </Button>
                                </div>

                                {
                                    showSuccess && (
                                        <div style={{width: '100%', backgroundColor: '#7bed9f', padding: 8, marginTop: 12, fontSize: '13pt'}}>
                                            We have e-mailed your password link!
                                        </div>
                                    )
                                }
                            </Form>
                            <br/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}